export const NO_PAYMENT_METHOD_NEEDED = 'NO_PAYMENT_METHOD_NEEDED';
